import {Component, Input, OnInit} from '@angular/core';
import {Card} from "../../models/links.model.interface";

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsComponent {

    @Input() items: Card[]

}
